import { render, staticRenderFns } from "./ViewOrder.vue?vue&type=template&id=af272fdc&scoped=true&"
import script from "./ViewOrder.vue?vue&type=script&lang=js&"
export * from "./ViewOrder.vue?vue&type=script&lang=js&"
import style0 from "./ViewOrder.vue?vue&type=style&index=0&id=af272fdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af272fdc",
  null
  
)

export default component.exports